// Modifica qui tutti i collegamenti esterni del sito
export const LINKS = {
  TEMPIO_VIVO: "https://tempio.fedefitnessitalia.it",
  DESERTO: "https://deserto.fedefitnessitalia.it",
  TEMPIO_APP: "https://tempiovivoapp.fedefitnessitalia.it",
  UOMO_BIBLICO: "https://uomobiblico.fedefitnessitalia.it",
  DONNA_VIRTUOSA: "https://donnavirtuosa.fedefitnessitalia.it",
  APP: "https://deserto.fedefitnessitalia.it",
  SHOP: "https://fedefitnessitalia.shop",
  INSTAGRAM: "https://www.instagram.com/fede_fitness_italia/",
  TIKTOK: "#",
  YOUTUBE: "#",
};
